<template lang="pug">
  .settings-client-dropdown
    v-dropdown(
      ref="dropdown"
      width-auto
      position-right)
      v-btn(
        icon
        :loading="loading"
        @click="onClick")
        i.i-util-more
        //- v-icon(
          font-size="1.2"
          icon="cog")
      .settings-client-dropdown__content(
        v-if="loaded"
        slot="content")
        v-card(
          elevated)
          v-card-title
            h2.card-title.mb-3 {{ 'activities.user_params' | translate }}
            //- v-switch.mb-3(
              label="Доступ Profeed"
              v-model="form.profeed")
            v-switch.mb-3(
              :label="$t('activities.access_kkz')"
              v-model="form.kkz"
              @input="update")
            v-switch.mb-3(
              :label="$t('activities.activate_client')"
              v-model="form.is_active"
              @input="update")

          v-divider(
            secondary)

          v-card-title
            h2.card-title.mb-3 {{ 'base.action' | translate }}
          v-card-actions
            .settings-client-dropdown__group
              v-btn(
                small
                ghost
                @click="editClick")
                v-icon(
                  position-left
                  font-size="1"
                  icon="pencil-alt")
                span {{this.$t('activities.edit')}}
            .settings-client-dropdown__group
              v-btn(
                ghost
                small
                @click="changeClick")
                v-icon(
                  position-left
                  font-size="1"
                  icon="key")
                span {{ 'auth.changes_password' | translate }}
            //- .settings-client-dropdown__group
            //-   delete-btn(
            //-     @delete="deleteClients")
            //-     v-btn(
            //-       small
            //-       danger
            //-       ghost)
            //-       v-icon(
            //-         position-left
            //-         font-size="1"
            //-         :icon="['far', 'trash-alt']")
            //-       span {{ 'base.delete' | translate }}

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DeleteBtn from '@/components/common/delete-btn/DeleteBtn'

export default {
  name: 'SettingsClientDropdown',

  components: {
    DeleteBtn
  },

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    form: {
      profeed: false,
      kkz: false,
      is_active: false
    },
    client: null,
    loading: false,
    loaded: false
  }),

  computed: {
    ...mapGetters('dashboard', [
      'currentUser'
    ])
  },

  methods: {
    ...mapActions('dashboard', [
      'getUser',
      'updateUser'
    ]),

    async onClick () {
      this.loaded = false
      this.loading = true
      await this.getUser(this.id)
      this.form.is_active = this.currentUser.is_active
      this.form.profeed = this.currentUser.modules.some(item => item === 'profeed')
      this.form.kkz = this.currentUser.modules.some(item => item === 'animalfeed')
      this.loaded = true
      this.loading = false
    },

    async update () {
      this.loading = true
      const payload = {
        id: this.currentUser.id,
        email: this.currentUser.email,
        user_type: this.currentUser.user_type,
        is_active: this.form.is_active,
        profile: {
          about: this.currentUser.profile.about,
          language: this.currentUser.profile.language
        },
        modules: []
      }
      if (this.form.profeed) {
        payload.modules.push('profeed')
      }
      if (this.form.kkz) {
        payload.modules.push('animalfeed')
      }
      await this.updateUser(payload)
      this.loading = false
    },

    editClick () {
      this.$emit('edit')
    },

    changeClick () {
      this.$emit('change')
    }
  }
}
</script>

<style lang="scss" scoped>
  .settings-client-dropdown {
    &__content {
      width: 38rem;
    }

    &__group:not(:last-child) {
      margin-bottom: 2rem;
    }
  }
</style>
